import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconApps = props => {
    return (
        <SvgIcon viewBox="0 0 16.042 17.002" fontSize="small" {...props}>
            <path
                d="M4.308,8.9l7.335,4.668a.667.667,0,0,0,.72,0L19.7,8.9a.667.667,0,0,0,0-1.12L12.363,3.107a.667.667,0,0,0-.72,0L4.308,7.775a.667.667,0,0,0,0,1.12Z"
                transform="translate(-4.003 -3.002)"
            />
            <path
                d="M19.044,15.116l-7,4.45-7-4.45a.669.669,0,0,0-.723,1.124l7.361,4.684a.669.669,0,0,0,.723,0l7.361-4.684a.669.669,0,0,0-.723-1.124Z"
                transform="translate(-4.003 -7.029)"
            />
            <path
                d="M19.044,20.116l-7,4.45-7-4.45a.669.669,0,0,0-.723,1.124l7.361,4.684a.669.669,0,0,0,.723,0l7.361-4.684a.669.669,0,0,0-.723-1.124Z"
                transform="translate(-4.003 -9.029)"
            />
        </SvgIcon>
    );
};
